export default __webpack_public_path__ + "assets/_Chapters/_Images/background/ServicesZerspanung/2.webp";